import React from 'react';
import { FieldValues, Path, UseFormReturn, useWatch } from 'react-hook-form';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  InfoIconTooltip,
  Switch,
} from '@ais-ui/ui-core';
import { MiscellaneousField } from '../../reportsTypes';

interface ShowTracksFormFieldProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  name?: Path<T>;
  fieldConfig?: MiscellaneousField;
  shipsFieldName?: Path<T>;
}

export const ShowTracksFormField = <T extends FieldValues>({
  form,
  name = 'miscellaneous.showTracks' as Path<T>,
  fieldConfig,
  shipsFieldName = 'ships' as Path<T>,
}: ShowTracksFormFieldProps<T>) => {
  const ships = useWatch({ control: form.control, name: shipsFieldName });
  const hasVessels = Array.isArray(ships) && ships.length > 0;

  const label = fieldConfig?.name ?? 'Show tracks';
  const help = fieldConfig?.help ?? 'Show tracks for selected vessels';
  const required = fieldConfig?.required ?? true;

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex flex-col space-y-4">
          <div className="flex justify-between">
            <FormLabel
              className={
                !hasVessels ? 'cursor-not-allowed opacity-50' : undefined
              }
            >
              {label}
              {required ? ': *' : ''}
            </FormLabel>
            <InfoIconTooltip>{help}</InfoIconTooltip>
          </div>
          <FormControl>
            <Switch
              checked={!!field.value}
              onCheckedChange={field.onChange}
              disabled={!hasVessels}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};
